module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kd-Ld.df56d915.png";